import { widgetApi } from "../services/api";

export interface CashPickupHabit {
  stateCode: string;
  payerId: string;
  destinationCountry: string;
  lastUsedAt: string;
}

interface ListHabitsApiResponse {
  success: boolean;
  data: CashPickupHabit[];
}

export const listCashPickupHabits = async (
  linkId: string,
  destinationCountry: string
): Promise<CashPickupHabit[]> => {
  const country = destinationCountry.trim();
  if (!linkId || !country) return [];
  try {
    const { data } = await widgetApi.get<ListHabitsApiResponse>(
      `/widget/links/${linkId}/cash-pickup-habits`,
      { params: { destinationCountry: country } }
    );
    return data.data ?? [];
  } catch {
    return [];
  }
};
